module.exports = __webpack_public_path__ + "static/bandit_captain-b07456a848eb1a1df1406c208a805e98.jpg";